import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Anchor from '../../../UniformComponents/Anchor'
import IntranetStore from '../IntranetStore'

@observer
class Intranet extends Component {
    constructor(props) {
        super(props)
        this.IntranetStore = new IntranetStore()
    }

    componentDidMount() {
        const { store } = this.props

        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
        ]
    }

    renderList = (items, title) => (
        <ul>
            <li className="listStyle">{title}</li>
            {
                items.map((item) => (
                    <li className="listStyle">
                        <i className={item.icon} />
                        <Anchor
                            isExternal
                            href={item.href}
                            style={{ marginLeft: '20px' }}
                        >
                            {item.label}
                        </Anchor>
                    </li>
                ))
            }
        </ul>
    )

    render() {
        return (
            <Fragment>
                <div className="colList">
                    {this.renderList(this.IntranetStore.generalItems, 'General')}
                </div>
                <div className="colList">
                    {this.renderList(this.IntranetStore.databaseItems, 'Data & Database')}
                </div>
                <div className="colList">
                    {this.renderList(this.IntranetStore.utilityItems, 'Utilities')}
                </div>
                <div style={{ position: 'fixed', bottom: '20px', left: '70px' }}>
                    {process.env.VERSION}
                </div>
            </Fragment>

        )
    }
}
export default Intranet
